// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + ({"4064":"PaymentRequestUi","4865":"KycOnboarding","4914":"ExternalIntegrationUi","8193":"ShippingLabel","9535":"PaymentRequestOverview"}[chunkId] || chunkId) + ".mp." + {"4064":"05556194","4865":"475cae3f","4914":"fd9255e0","8193":"e55e393d","8711":"48b7b28a","9535":"6921b676"}[chunkId] + ".css";
};